<template>
  <div class="row">
    <div class="col-md-3 col-sm-6 col-lg-2">
      <hk-select v-model="optionSelected" placeholder="Seleccione una opcion" :options="optionsRows"></hk-select>
    </div>
    <label class="col-4 pt-2">
      {{ $t('key_text_rows_per_page') }}
    </label>
  </div>
</template>
<script>
import HkSelect from "@/hotaka/components/HkSelect.vue";

export default {
  name: "EntriesPerPage",
  components:{
    HkSelect
  },
  props: {
    options: {
      type: Array,
      default: null,
    },
    current: {
      type: Number,
      default: 10,
    }
  },
  emits: ['change'],
  data() {
    return {
    optionSelected: 20,
    optionsRows: [
      { value: 5, label: "5" },
      { value: 10, label: "10" },
      { value: 15, label: "15" },
      { value: 20, label: "20" },
      { value: 50, label: "50" },
    ]
    };
  },
  watch:{
    optionSelected(val){
      if (val != this.current) {
        this.$emit('change', val);
      }
    },
    current(){
      this.optionSelected = this.current;
    }
  },
  mounted() {
    this.optionSelected=this.current;
  }
};
</script>
<style >
.fullTable-selector{
  width:50%;
}
</style>
